module.exports = __webpack_public_path__ + "5ee7a2511dfa364fb209bd584675f0b1.png";